import { Injectable } from '@angular/core';
import { FilterResponse, GetFilterResponse } from './models/filter-response.model';
import { Filter, GetFilter } from './models/filter.model';

@Injectable({
  providedIn: 'root',
})
export class FiltersFactory {
  buildGetFilterFromResponse(response: GetFilterResponse): GetFilter {
    return {
      label: response.label,
      name: response.name,
      data: response.values.map((values) => this.buildFilterFromResponse(values)),
      page: response.page + 1,
      size: response.size,
      total: response.total,
    }
  }

  buildFilterFromResponse(response: FilterResponse): Filter {
    return {
      count: response.value,
      name: response.nameToShow,
      value: response.name
    }
  }
}
